// extracted by mini-css-extract-plugin
export default {"zoomModal":"x3-z","image":"y3-z","button":"z3-z","isOverlayShown":"A3-z"};